import React, { useEffect, useState, useRef } from 'react';
import { ButtonLoading, SimpleDialog, Icons, NewLoading } from 'components';
import { Grid, Button } from '@mui/material';
import clsx from 'clsx';
import { useStyles } from './Style';
import { getAutoLoginService } from './Services';
const AutoLoginExporReportPages = ({ urlType, params, classBtn = null }) => {
  const [isOpenDg, setIsOpenDg] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const classes = useStyles();

  const openNewTab = (url) => {
    setIsLoading(false);
    setIsOpenDg(false);
    window.open(url, '_blank');
  };

  /**
   * btnType : دو دکمه داریم که هر کدوم رو کلیک کنه یک تایپ دارد
   * urlType: براساس پراپز از سمت پرنت ارسال میشود و از داخل سرویس ها ، آدرس سرویس مورد نظر را از اینام کال میکند
   */
  const getDataService = (btnType) => {
    var firstDate = new Date();
    const typeService = {
      export_format_bank: urlType?.exportFormatBank,
      export_detail: urlType?.exportDetails,
    };
    setIsLoading(true);
    getAutoLoginService(typeService[btnType], params)
      .then((res) => {
        const secondDate = new Date();
        let timeBetween = secondDate - firstDate;
        if (timeBetween < 6000) {
          const timeSecond = Math.ceil(timeBetween / 1000);
          setTimeout(() => {
            openNewTab(res?.result);
          }, (6 - timeSecond) * 1000);
        } else {
          openNewTab(res?.result);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  return (
    <React.Fragment>
      <ButtonLoading
        variant="contained"
        onClick={() => {
          setIsOpenDg(true);
        }}
        startIcon={<Icons icon="ReceiveSquare" color="#fff" size="23" />}
        color="primary"
        name="دریافت خروجی"
        aria-controls="simple-menu"
        aria-haspopup="true"
        className={classBtn ? classBtn : classes.exportBtn}
      />

      <SimpleDialog
        fullWidth
        maxWidth="sm"
        customClass={classes.contentDg}
        open={isOpenDg}
        icon={<Icons icon="OpenNewTab" color="#303DBF" size="20" />}
        title={'دریافت خروجی'}
        onClose={() => !isLoading && setIsOpenDg(false)}
        style={{ padding: '30px' }}
      >
        <Grid container alignItems="center">
          <div className={classes.mainContent}>
            <p className={classes.description}>
              کاربر گرامی جهت انتخاب نوع گزارش، یکی از موارد زیر را انتخاب نمایید:
            </p>
            <Grid item justifyContent={'space-between'} className={classes.gridColumn}>
              <>
                <div key={1} className={classes.box}>
                  <Button
                    className={clsx(classes.blockReport, '')}
                    onClick={() => getDataService('export_format_bank')}
                  >
                    <Icons
                      icon="ReceiveSquare"
                      color="#2B398E"
                      size="30"
                      className={classes.icons}
                    />
                    <span>دریافت خروجی با فرمت بانکی </span>
                  </Button>
                </div>
                <div key={2} className={classes.box}>
                  <Button
                    className={clsx(classes.blockReport, '')}
                    onClick={() => getDataService('export_detail')}
                  >
                    <Icons
                      icon="ReceiveSquare"
                      color="#2B398E"
                      size="30"
                      className={classes.icons}
                    />
                    <span>دریافت خروجی با جزئیات </span>
                  </Button>
                </div>
              </>
              {isLoading && (
                <div className={classes.loadingContent}>
                  <span className={classes.messageLoading}>درحال ورود به پنل گزارش ساز</span>
                  <NewLoading />
                </div>
              )}
            </Grid>
          </div>
        </Grid>
      </SimpleDialog>
    </React.Fragment>
  );
};

export default AutoLoginExporReportPages;
